import React, { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import LoadingPage from '../../src/component/loading';
import useAuth from '../../src/auth/use-auth';
import { RoutesEnum } from '../../src/types/routes.enum';
import { useTranslation } from 'react-i18next';

function Page() {
    const { logout } = useAuth();
    const router = useRouter();
    const { t } = useTranslation();

    const getQueryParams = useCallback(() => {
        const query: {
            [key: string]: string | string[] | boolean | undefined;
        } = {
            logout: true,
        };
        if (router.query['info']) {
            query.info = router.query['info'];
        }
        if (router.query['state']) {
            query.state = router.query['state'];
        }
        if (router.query['redirectTo']) {
            query.redirectTo = router.query['redirectTo'];
        }
        return query;
    }, [router.query]);

    useEffect(() => {
        logout().finally(() => {
            router.push({
                pathname: RoutesEnum.LOGIN,
                query: getQueryParams(),
            });
        });
    }, [getQueryParams, logout, router]);

    return <LoadingPage message={t('loadingPage.loggingOut')} />;
}

export default Page;
